import { createAction } from 'redux-action';
import axios from 'axios';
import {
  AxiosCallError,
  AxiosCallRequest,
  AxiosCallSuccess,
  showErrorPage,
  WSConnected,
  WSDisconnected,
} from './commonActions';
import { get_service_endpoint } from '../../ServiceEndpoints.js';
import { history } from '../../index';
import { selectedTab } from '../reducers/AssessmentReducer';
import { setAssessment } from './InviteActions';
import { setQuestionDetails } from './McqActions';
import { endMeetingSession } from './AssesmentRecordingActions.js';
import serializeSections from '../../Utils/sectionsSerializer';
import { sectionInfoSerializer } from '../../Utils/utils.js';
import {
  HEARTBEAT_TYPE_OVERALL,
  HEARTBEAT_TYPE_SECTION,
  SECTION_STATUS_IN_PROGRESS,
  SECTION_STATUS_ENDED,
  ASSESSMENT_NOT_IN_PROGRESS,
  ResultStatus,
  LogoStatus,
} from '../../const';

export const SET_CUSTOM_INPUT_LOADING = 'SET_CUSTOM_INPUT_LOADING';
export const CLEAR_CUSTOM_INPUT_LOADING = 'CLEAR_CUSTOM_INPUT_LOADING';

let ep = get_service_endpoint('assessment');

export const resetTestCaseResultStatus = createAction('RESET_TC_RES_STATUS');
export const setCustInpResults = createAction('SET_CUSTOM_INP_RESULTS');
export const resetCustInpResults = createAction('RESET_CUSTOM_INP_RESULTS');

//sets the tab being viewed - prob desc, output or testcases
export const chooseOption = createAction('CHOOSE_OPTION');

export const SetInviteCredential = createAction('SET_INVITE_CREDENTIAL');

export const startTestSuccess = createAction('START_TEST_SUCCESS');

export const updateAssessment = createAction('UPDATE_ASSESSMENT');

export const assignLogo = createAction('ASSIGN_LOGO');
export const updateStatus = createAction('UPDATE_STATUS');

export const assignTestCaseData = createAction('ASSIGN_TESTCASE_DATA');
export const updateTestCaseData = createAction('UPDATE_TESTCASE_DATA');
export const addToExecutionList = createAction('ADD_TO_EXECUTION_LIST');
export const removeFromExecutionList = createAction('REMOVE_FROM_EXECUTION_LIST');

//selects a single problem to work on
export const assignProblem = createAction('ASSIGN_PROBLEM');
export const assignTestcases = createAction('ASSIGN_TESTCASES');
export const assignTemplate = createAction('EDITOR_ASSIGN_TEMPLATE');

//removes all the base code set in ASSIGN_TEMPLATES action
export const resetAll = createAction('EDITOR_RESET_ALL');

export const markAttempted = createAction('MARK_ATTEMPTED');

export const setTimerExpLevel = createAction('SET_TIMER_EXP_LEVEL');

export const setMcqResponses = createAction('SET_MCQ_RESPONSES');
export const setCurrentSectionId = createAction('SET_CURRENT_SECTION_ID');
export const updateSectionInfo = createAction('UPDATE_SECTION_INFO');
export const updateOverallTimer = createAction('UPDATE_OVERALL_TIMER');
export const updateSectionTimer = createAction('UPDATE_SECTION_TIMER');
export const updateSectionStatusLocal = createAction('UPDATE_SECTION_STATUS');
export const SET_ASSESSMENT_SUBMITTED = 'SET_ASSESSMENT_SUBMITTED';

export const setSubmittedBy = value => {
  return dispatch => {
    dispatch({ type: 'SET_SUBMITTED_BY', payload: value });
    return Promise.resolve();
  };
};

export const setAssessmentSubmitted = () => ({
  type: SET_ASSESSMENT_SUBMITTED,
});

export const setCustomInputStdin = createAction('SET_CUSTOM_INPUT_STDIN');

export const createMeetingSuccess = createAction('CREATE_MEETING');
export const getMeetingSuccess = createAction('GET_MEETING');
export const getAttendeeSuccess = createAction('GET_ATTENDEE');
export const getTestSettingsSuccess = createAction('GET_TEST_SETTINGS');
export const getTestInfoSuccess = createAction('GET_TEST_INFO');
export const getSurveyUrlSuccess = createAction('GET_SURVEY_URL_SUCCESS');
export const startRecordingSuccess = createAction('START_RECORDING');
export const stopRecordingSuccess = createAction('STOP_RECORDING');

export const showModal = createAction('SHOW_MODAL');
export const clearModal = createAction('CLEAR_MODAL');

export const fetchAssessment = (assessment_id, problem_id, onlySection) => {
  return (dispatch, getState) => {
    dispatch(AxiosCallRequest());
    axios
      .get(`${ep}/api/assessments/${assessment_id}/`)
      .then(response => {
        if (response.data.status !== 'PG') {
          dispatch(
            showErrorPage({
              errorType: 'Application Error',
              errorHeading: 'Assessment Complete',
              errorMessage: 'This assessment is complete and can no longer be viewed',
            }),
          );
          history.push('/error');
        } else {
          dispatch(updateAssessment(response.data));
          dispatch(setAssessment(response.data));
          dispatch(fetchTestCasesData(response.data));
          dispatch(selectProblem(problem_id, false));

          // Set currentSectionId to current section's ID if sections exist and not already set
          const { sections: serializedSections, currentSection } = serializeSections(
            response.data.sections,
            window.location.pathname,
          );
          if (currentSection && !getState().assessment.currentSectionId) {
            dispatch(setCurrentSectionId(currentSection.id));
          }
        }
        dispatch(AxiosCallSuccess());
      })
      .catch(error => {
        if (error.response) {
          if (error.response.status === 401) {
            dispatch(
              showModal({
                name: 'unauthorized_access',
                type: 'error',
                title: 'Unauthorized access',
                content: 'Please make sure you are logged in as the user who received the invite',
              }),
            );
          }
        }
        dispatch(AxiosCallError());
      });
  };
};

export const fetchSurveyUrl = (type, role = '', callback = null) => {
  return dispatch => {
    dispatch(AxiosCallRequest());
    let url = `${ep}/api/survey/url/?type=${type}`;
    if (role) url += `&role=${role}`;
    return axios
      .get(url)
      .then(res => {
        dispatch(getSurveyUrlSuccess(res.data.survey_url));
        dispatch(AxiosCallSuccess());
        if (callback) callback(res.data.survey_url);
      })
      .catch(error => {
        dispatch(AxiosCallError());
        if (callback) callback(null);
      });
  };
};

const assignLogoAndStatus = ({ id, logo, pending_tc }) => {
  return dispatch => {
    let logo_list = Object.values(logo);
    let passCases = logo_list.filter(logo => logo === LogoStatus.Accepted).length;
    let totalCases = logo_list.length;
    let notAttempted = logo_list.filter(logo =>
      [LogoStatus.Unknown, LogoStatus.NotAttempted].includes(logo),
    ).length;
    let failedCases = logo_list.filter(logo =>
      [
        LogoStatus.TimeLimit,
        LogoStatus.WrongAnswer,
        LogoStatus.CompilerError,
        LogoStatus.RuntimeError,
      ].includes(logo),
    ).length;
    let status = '';
    if (pending_tc === 0) {
      if (passCases === totalCases) {
        status = 'ALL_PASS';
      } else if (notAttempted === totalCases) {
        status = LogoStatus.NotAttempted;
      } else if (failedCases === totalCases) {
        status = 'ALL_FAIL';
      } else if (passCases > 0) {
        status = 'SOME_PASS';
      }
    }
    dispatch(assignLogo({ id, logo, status }));
  };
};

export const fetchTestCasesData = res => {
  return dispatch => {
    res.problems.forEach(prob => {
      if (prob.codesubmission_id && prob.codesubmission_id !== null) {
        dispatch(fetchTestCaseExecResults(prob.id, prob.codesubmission_id));
      } else {
        let tc_logo = {};
        prob.testcases.forEach(t => {
          tc_logo[t.id] = LogoStatus.NotAttempted;
        });
        dispatch(assignLogoAndStatus({ id: prob.id, logo: tc_logo }));
      }
    });
  };
};

export const selectProblem = (problem_id, hist_push = true) => {
  return (dispatch, getState) => {
    dispatch(assignProblem({ problem_id: problem_id }));
    dispatch(
      chooseOption({
        activeTab: selectedTab.problemStatement,
        problem_id: problem_id,
      }),
    );
    if (hist_push) {
      history.push(`/assessment/${getState().assessment.id}/problem/${problem_id}`);
    }
  };
};

// Helper function to end all sections
const endAllSections = sections => {
  return async dispatch => {
    if (sections && sections.length > 0) {
      // Filter sections that are not already ended
      const sectionsToEnd = sections.filter(section => section.status !== SECTION_STATUS_ENDED);

      if (sectionsToEnd.length > 0) {
        const endSectionPromises = sectionsToEnd.map(section =>
          dispatch(updateSectionStatus(section.id, SECTION_STATUS_ENDED)),
        );
        await Promise.all(endSectionPromises);
      }
    }
  };
};

export const submitAssessment = (assessmentId, redirect = true) => {
  return async (dispatch, getState) => {
    await dispatch({ type: 'SET_ASSESSMENT_STATUS', payload: 'In progress' });
    dispatch(AxiosCallRequest());
    const { meetingData } = getState().assessment;
    const { meetingSession } = getState().assesmentRecording;
    if (meetingData && meetingData?.id) {
      dispatch(stopRecording(meetingData.id));
      dispatch(endMeetingSession(meetingSession));
    }

    // End all sections before submitting
    const { sections } = getState().assessment;
    await dispatch(endAllSections(sections));

    const submitCodePromises = [];
    getState().assessment.problems.forEach(problem => {
      if (!problem.attempted && problem.editor && problem.editor.isDirty) {
        problem.templates.forEach(template => {
          if (problem.editor.isDirty[template.language]) {
            let data = {
              assessment_id: assessmentId,
              problem_id: problem.id,
              code_body: problem.editor.code[template.language]
                .replace(template.header, '')
                .replace(template.tailer, ''),
              language: template.language,
              cs_type: 'regular',
              auto_submitted: true,
            };
            submitCodePromises.push(axios.post(`${ep}/api/codesubmissions/`, data));
          }
        });
      }
    });

    Promise.all(submitCodePromises).finally(() => {
      const body = {};
      axios
        .post(`${ep}/api/assessments/${assessmentId}/end_assessment/`, body)
        .then(async response => {
          dispatch(AxiosCallSuccess());
          if (window.webSocketObj)
            // if WS connection exists close it
            window.webSocketObj.close();
          if (redirect) {
            await dispatch(setSubmittedBy('candidate'));
            history.push(`/survey/assessment/${assessmentId}`);
          }
          sessionStorage.clear();
          dispatch({ type: 'SET_ASSESSMENT_STATUS', payload: 'Submitted' });
          dispatch(setAssessment({ id: assessmentId, status: 'CM' }));
        })
        .catch(error => {
          if (error.response) {
            if (error.response.status === 401) {
              dispatch(
                showModal({
                  name: 'unauthorized_access',
                  type: 'error',
                  title: 'Unauthorized access',
                  content: 'Please make sure you are logged in as the user who received the invite',
                }),
              );
            }
            if (error.response.status === 400) {
              dispatch(
                showModal({
                  name: 'assessment_error',
                  type: 'error',
                  title: 'An error occured',
                  content: error.response.data.msg,
                }),
              );
            }
          }
          dispatch(AxiosCallError());
        });
    });
  };
};

export const fetchCustomInputExecResults = (code_submission_id, problem_id, max_tries = 5) => {
  return dispatch => {
    const url = `${ep}/api/codesubmissions/${code_submission_id}/tc_executions/`;
    axios.get(url).then(res => {
      let ciResult;
      if (res.data.length > 0) ciResult = res.data[0];
      if (
        (res.data.length === 0 && max_tries > 0) ||
        (ciResult && ciResult.status === 'EX' && max_tries > 0)
      ) {
        window.setTimeout(() => {
          dispatch(fetchCustomInputExecResults(code_submission_id, problem_id, max_tries - 1));
        }, 2500);
      } else {
        dispatch(setCustInpResults({ tcResult: res.data[0], problem_id: problem_id }));
        dispatch(AxiosCallSuccess());
      }
    });
  };
};

export const fetchTestCaseExecResults = (prob_id, code_submission_id, max_tries = 10) => {
  return (dispatch, getState) => {
    const url = `${ep}/api/codesubmissions/${code_submission_id}/tc_executions/`;
    axios.get(url).then(res => {
      let tc_logo = {};
      let tc_executionData = {};
      res.data.forEach(tcResult => {
        tc_executionData[tcResult.testcase_id] = {
          compiler_error: tcResult.compiler_error,
          runtime_error: tcResult.runtime_error,
          stderr: tcResult.stderr,
          timelimitexceeded_error: tcResult.timelimitexceeded_error,
        };
        if (tcResult.compiler_error) {
          tc_logo[tcResult.testcase_id] = LogoStatus.CompilerError;
        } else if (tcResult.runtime_error) {
          tc_logo[tcResult.testcase_id] = LogoStatus.RuntimeError;
        } else if (tcResult.timelimitexceeded_error) {
          tc_logo[tcResult.testcase_id] = LogoStatus.TimeLimit;
        } else {
          if (tcResult.status === ResultStatus.Success) {
            tc_logo[tcResult.testcase_id] = LogoStatus.Accepted;
          } else if (tcResult.status === 'EX') {
            tc_logo[tcResult.testcase_id] = 'LOAD';
          } else if (tcResult.status === ResultStatus.Fail) {
            tc_logo[tcResult.testcase_id] = LogoStatus.WrongAnswer;
          } else {
            tc_logo[tcResult.testcase_id] = LogoStatus.Unknown;
          }
        }
      });
      // executed when we refresh the page and fetch last codesubmission.
      // If it is of type custom_input do not do anything.
      if (res.data.length === 1 && res.data[0].cs_type === 'custom_input') {
        return;
      } else {
        let problems = getState().assessment.problems;
        let num_testcases = problems.find(p => p.id === prob_id).testcases.length;
        let pending_tcs =
          res.data.filter(tcResult => tcResult.status === 'EX').length +
          (num_testcases - res.data.length);
        dispatch(assignLogoAndStatus({ id: prob_id, logo: tc_logo, pending_tc: pending_tcs }));
        dispatch(assignTestCaseData({ id: prob_id, tc_executionData }));
        if (pending_tcs > 0 && max_tries > 0) {
          window.setTimeout(() => {
            dispatch(fetchTestCaseExecResults(prob_id, code_submission_id, max_tries - 1));
          }, 2500);
        } else {
          dispatch(WSDisconnected());
        }
      }
    });
  };
};

export const submitCode = data => {
  return (dispatch, getState) => {
    let executionResults = [];
    let WSConnectionStatus = getState().global.WSConnectionStatus;
    if (!WSConnectionStatus) {
      let wsep = get_service_endpoint('common-ws');
      let urlStub = window.location.hostname.split('.').reverse();
      let rootDomain = '.' + urlStub[1] + '.' + urlStub[0];
      // setting domain cookie for ws authentication
      document.cookie =
        'access_token=' + localStorage.getItem('access-token') + ';path=/;domain=' + rootDomain;
      document.cookie =
        'refresh_token=' +
        localStorage.getItem('refresh-token') +
        ';path=/;max-age=60;domain=' +
        rootDomain;
      const ws = new WebSocket(`${wsep}/submit_code/?assessment_id=${data.id}`);

      ws.onopen = () => {
        dispatch(WSConnected());
      };

      ws.onmessage = event => {
        const message = JSON.parse(event.data);
        if (message.type === 'code_executed') {
          if (message.data.cs_type === 'regular') {
            dispatch(AxiosCallSuccess());
            dispatch(updateTestCaseExecResults(message.data));
          }
          executionResults.push(message.data);
          dispatch(handleExecutionResults(executionResults));
        }
      };

      ws.onerror = error => {
        dispatch(
          showModal({
            name: 'ws_error',
            type: 'warning',
            title: 'Unable to fetch results',
            content:
              'An error occured while fetching the result, please refresh the page to fetch the results again.',
            okText: 'Refresh page',
            onOk: () => {
              window.location.reload();
            },
          }),
        );
      };

      window.webSocketObj = ws;
    }
    // Always submit the code via API
    dispatch(postCodeSubmission(data));
  };
};

//Keeping it for future
export const chimeEventsSocket = (meeting_id, assessment_id) => {
  return (dispatch, getState) => {
    let wsep = get_service_endpoint('common-ws');
    dispatch(AxiosCallRequest());
    let urlStub = window.location.hostname.split('.').reverse();
    let rootDomain = '.' + urlStub[1] + '.' + urlStub[0];
    // setting domain cookie for ws authentication
    document.cookie =
      'access_token=' + localStorage.getItem('access-token') + ';path=/;domain=' + rootDomain;
    document.cookie =
      'refresh_token=' +
      localStorage.getItem('refresh-token') +
      ';path=/;max-age=60;domain=' +
      rootDomain;
    let WSConnectionStatus = getState().global.WSConnectionStatus;
    // connect to ws if not connected already
    if (!WSConnectionStatus) {
      const ws = new WebSocket(
        `${wsep}/chime_events/?meeting_id=${meeting_id}&assessment_id=${assessment_id}`,
      );

      ws.onopen = () => {
        console.log('Chime events WS connected');
        dispatch(WSConnected());
        dispatch(AxiosCallSuccess());
      };

      ws.onmessage = event => {
        const message = JSON.parse(event.data);
        console.log('Message received from chime events ws:', message);
      };

      ws.onerror = error => {
        console.log('Error in chime events ws:', error);
      };

      window.webSocketObj = ws;
    }
  };
};

const postCodeSubmission = data => {
  return (dispatch, getState) => {
    const url = `${ep}/api/codesubmissions/`;
    const body = {
      assessment_id: data.id,
      problem_id: data.problem_id,
      code_body: data.code_body,
      language: data.language,
      cs_type: data.cs_type,
    };
    if (data.cs_type === 'custom_input') {
      body['ci_stdin'] = data.ci_stdin;
      dispatch({ type: SET_CUSTOM_INPUT_LOADING, payload: { problem_id: data.problem_id } });
    } else {
      dispatch(resetTestCaseResultStatus({ logo: 'LOAD' }));
    }
    // submit code
    let prob = getState().assessment.problems.find(p => p.id === data.problem_id);
    let num_testcases;
    if (data.cs_type === 'custom_input') num_testcases = 1; // custom input
    else num_testcases = prob.testcases.length; // regular submission
    axios
      .post(url, body)
      .then(response => {
        // add to execution list
        let payload = {
          codesubmission_id: response.data.id,
          problem_id: prob.id,
          cs_type: data.cs_type,
          num_testcases: num_testcases,
        };
        dispatch(addToExecutionList(payload)); // adds the codesubmission to execution list
        if (data.cs_type === 'regular') {
          dispatch(
            chooseOption({
              activeTab: selectedTab.results,
              problem_id: data.problem_id,
            }),
          );
        }
        let curr_timer = sessionStorage.getItem('curr_timer'); // get existing timeout ID if any
        sessionStorage.removeItem('curr_timer');
        window.clearTimeout(curr_timer); // clear existing timeout
        setTimeout(() => {
          const assessment = getState().assessment;
          const executionList = assessment.executionList;
          if (executionList.length > 0) {
            const lastExecution = executionList[executionList.length - 1];
            if (lastExecution.cs_type === 'custom_input') {
              dispatch(
                fetchCustomInputExecResults(
                  lastExecution.codesubmission_id,
                  lastExecution.problem_id,
                ),
              );
            } else {
              const currProblem = assessment?.problems?.filter(problem => problem.isCurrent)[0];
              if (
                currProblem &&
                currProblem.id &&
                currProblem.testcases &&
                assessment.executionList &&
                assessment.executionList.length > 0 &&
                assessment.executionList[assessment.executionList.length - 1]?.codesubmission_id
              ) {
                let loading = currProblem.testcases.some(tc => tc.logo === 'LOAD');
                if (loading) {
                  dispatch(
                    fetchTestCaseExecResults(
                      currProblem.id,
                      assessment.executionList[assessment.executionList.length - 1]
                        .codesubmission_id,
                      6,
                    ),
                  );
                }
              }
            }
          }
        }, 5000);
        let timer = window.setTimeout(() => {
          dispatch(handleExecutionTimeout(timer, data.problem_id));
        }, 20000); // add new timeout
        sessionStorage.setItem('curr_timer', timer); // persist new timeout
      })
      .catch(err => {
        // error in submitting the code
        dispatch(
          showModal({
            name: 'code_submission_error',
            type: 'warning',
            title: 'Unable to submit the code',
            content: 'An error occured in submitting the code, please try again in some time.',
          }),
        );
        dispatch(AxiosCallSuccess());
      });
  };
};

const handleExecutionTimeout = (timer, problemId) => {
  return (dispatch, getState) => {
    // Extract problem ID from URL
    const urlPath = window.location.pathname;
    const urlProblemId = urlPath.split('/problem/')[1];

    // Only execute if the problem ID from URL matches the passed problemId
    if (urlProblemId && urlProblemId === problemId) {
      window.clearTimeout(timer); // clear the timeout
      let executionList = getState().assessment.executionList;
      // get problems where not all testcases are passed
      let problems = getState().assessment.problems.filter(
        p => !p.status || p.status !== 'ALL_PASS',
      );
      // array of problem_ids
      problems = problems.map(p => p.id);
      let WSConnectionStatus = getState().global.WSConnectionStatus;
      if (executionList.length > 0 && WSConnectionStatus) {
        // only show modals if WS is connected, otherwise show page refresh modal
        let problemsInExecution = executionList.map(ex => ex.problem_id); //problem IDs in execution
        let availableProblems = problems.filter(p => !problemsInExecution.includes(p)); // problems IDs not in execution list
        const { currentSectionId, sectionProblems } = getState().assessment;

        const findNextProblem = problemList => {
          const currentIndex = problemList.findIndex(p => p.id === urlProblemId);
          if (currentIndex === -1) return null;
          for (let i = currentIndex + 1; i < problemList.length; i++) {
            if (availableProblems.includes(problemList[i].id)) {
              return problemList[i].id;
            }
          }
          return null;
        };

        const showConfirmModal = nextProblemId => {
          dispatch(
            showModal({
              name: 'execution_timeout_confirm',
              type: 'confirm',
              title: 'Execution taking longer to complete',
              content:
                'The system is taking longer than usual to execute the code, you can either wait for results or solve another problem in the meantime.',
              okText: 'Wait for result',
              cancelText: 'Try another problem',
              onCancel: () => {
                dispatch(AxiosCallSuccess());
                // switch to another problem
                if (nextProblemId) dispatch(selectProblem(nextProblemId));
              },
            }),
          );
        };

        if (currentSectionId && sectionProblems[currentSectionId]) {
          const problemsInSection = sectionProblems[currentSectionId];
          const nextProblemId = findNextProblem(problemsInSection);
          showConfirmModal(nextProblemId);
          dispatch(AxiosCallSuccess());
        } else {
          // no sections, use sequential navigation
          const allUnsolvedProblems = getState().assessment.problems.filter(
            p => !p.status || p.status !== 'ALL_PASS',
          );
          const nextProblemId = findNextProblem(allUnsolvedProblems);
          if (nextProblemId) {
            showConfirmModal(nextProblemId);
          } else {
            dispatch(
              showModal({
                name: 'execution_timeout_info',
                type: 'info',
                title: 'Execution taking longer to complete',
                content:
                  'The system is taking longer than usual to execute the code, please try again after some time',
              }),
            );
            dispatch(AxiosCallSuccess());
          }
        }
      }
    } else {
      window.clearTimeout(timer); // clear the timeout even if not executing
    }
  };
};

const updateTestCaseExecResults = data => {
  return dispatch => {
    let probId = data.problem_id;
    let tcResult = data.tc_result;
    let tcLogo;
    let tcExecutionData = {};
    tcExecutionData = {
      id: tcResult.testcase_id,
      compiler_error: tcResult.compiler_error,
      runtime_error: tcResult.runtime_error,
      stderr: tcResult.stderr,
      timelimitexceeded_error: tcResult.timelimitexceeded_error,
    };
    if (tcResult.compiler_error) tcLogo = LogoStatus.CompilerError;
    else if (tcResult.runtime_error) tcLogo = LogoStatus.RuntimeError;
    else if (tcResult.timelimitexceeded_error) tcLogo = LogoStatus.TimeLimit;
    else {
      if (tcResult.status === ResultStatus.Success) tcLogo = LogoStatus.Accepted;
      else if (tcResult.status === ResultStatus.Fail) tcLogo = LogoStatus.WrongAnswer;
      else tcLogo = LogoStatus.Unknown;
    }
    tcExecutionData['logo'] = tcLogo;
    dispatch(updateTestCaseData({ id: probId, tcExecutionData }));
  };
};

const handleExecutionResults = executionResults => {
  return (dispatch, getState) => {
    let executionList = getState().assessment.executionList;
    if (executionList.length > 0) {
      let lastTcResult = executionResults[executionResults.length - 1].tc_result; // last item in executionResults. executionResults hold WS messages
      let lastTcResultCodeSubmissionId = lastTcResult.code_submission_id; // codesubmission id of last item in executionResults
      let currExecutingItem = executionList.find(
        ex => ex.codesubmission_id === lastTcResultCodeSubmissionId,
      ); // current executin item in execution list
      let numExecutionResult = executionResults.filter(
        exr =>
          exr?.tc_result?.code_submission_id &&
          exr.tc_result.code_submission_id === lastTcResultCodeSubmissionId,
      ).length;

      console.log(currExecutingItem);

      if (currExecutingItem && currExecutingItem.num_testcases === numExecutionResult) {
        // for current executing item all test cases are recieved by WS
        if (currExecutingItem.cs_type === 'regular') {
          dispatch(markAttempted({ problem_id: currExecutingItem.problem_id }));
          dispatch(updateAttempStatus(currExecutingItem.problem_id, executionResults));
          dispatch(handleWSDisconnect(lastTcResultCodeSubmissionId));
        } else if (currExecutingItem.cs_type === 'custom_input') {
          dispatch(
            setCustInpResults({ tcResult: lastTcResult, problem_id: currExecutingItem.problem_id }),
          );
          dispatch({
            type: CLEAR_CUSTOM_INPUT_LOADING,
            payload: { problem_id: currExecutingItem.problem_id },
          });
          dispatch(handleWSDisconnect(lastTcResultCodeSubmissionId));
          dispatch(AxiosCallSuccess());
        }
      }
    }
  };
};

const handleWSDisconnect = codesubmission_id => {
  // removes a problem from execution list and checks if it was in the last problem in execution list. If yes, then disconnect WS.
  return (dispatch, getState) => {
    const promise = new Promise((resolve, reject) => {
      dispatch(removeFromExecutionList(codesubmission_id));
      resolve(codesubmission_id);
    });
    promise.then(res => {
      let executionList = getState().assessment.executionList;
      if (executionList.length === 0) {
        // execution list is empty, now we can close the websocket connection
        if (window.webSocketObj) {
          window.webSocketObj.close();
          delete window.webSocketObj;
        }
        dispatch(WSDisconnected());
      }
    });
  };
};

const updateAttempStatus = (prob_id, data) => {
  return dispatch => {
    // compute question attempt status
    let passCases = data.filter(item => item.tc_result.status === ResultStatus.Success).length;
    let failedCases = data.filter(
      item =>
        item.tc_result.compiler_error ||
        item.tc_result.runtime_error ||
        item.tc_result.timelimitexceeded_error ||
        item.tc_result.status === ResultStatus.Fail,
    ).length;
    let totalCases = data.length;
    let notAttempted = totalCases - passCases - failedCases;

    let status = '';
    if (passCases === totalCases) status = 'ALL_PASS';
    else if (notAttempted === totalCases) status = LogoStatus.NotAttempted;
    else if (failedCases === totalCases) status = 'ALL_FAIL';
    else if (passCases > 0) status = 'SOME_PASS';
    dispatch(updateStatus({ id: prob_id, status: status }));
  };
};

export const postEvent = data => {
  return (dispatch, getState) => {
    data['assessment_id'] = getState().invite.assessment_id;
    const url = `${ep}/api/events/`;
    axios
      .post(url, data)
      .then(res => {})
      .catch(err => {
        dispatch(AxiosCallError(err));
      });
  };
};

export const recordResponse = (mcqId, answer) => {
  return async (dispatch, getState) => {
    const {
      invite: { assessment_id, test_id },
      auth: { user_id },
    } = getState();
    let url = `${ep}/api/assessments/${assessment_id}/record_responses/`;

    let payload = {
      mcq_id: mcqId,
      user_id,
      test_id,
      selected_options: answer,
    };
    try {
      const res = await axios.post(url, payload);
      return res;
    } catch (error) {
      console.log(error);
      throw error;
    }
  };
};

export const getRecoredResponses = assessmentId => {
  return (dispatch, getState) => {
    dispatch(AxiosCallRequest());
    let url = `${ep}/api/assessments/${assessmentId}/mcqsubmissions/`;
    return axios
      .get(url)
      .then(res => {
        dispatch(AxiosCallSuccess());
        dispatch(setMcqResponses(res.data));

        // Also update questionDetails in MCQ reducer
        const state = getState();
        const questionDetails = state.mcq.questionDetails;

        if (questionDetails && questionDetails.length > 0 && res.data && Array.isArray(res.data)) {
          const newDetails = questionDetails.map(detail => ({ ...detail }));
          let hasChanges = false;
          res.data.forEach(response => {
            const index = newDetails.findIndex(x => x.id === response.mcq_id);
            if (index !== -1) {
              const options = response.selected_options_out.map(option => {
                return JSON.stringify({
                  id: option.option_id,
                  text: option.text,
                  order: option.question_order,
                });
              });
              if (options.length > 0) {
                newDetails[index] = { ...newDetails[index], answer: options, answered: true };
                hasChanges = true;
              }
              if (response.status.marked_for_review && !newDetails[index].markedForReview) {
                newDetails[index] = { ...newDetails[index], markedForReview: true };
                hasChanges = true;
              }
              if (response.status.is_seen && !newDetails[index].visited) {
                newDetails[index] = { ...newDetails[index], visited: true };
                hasChanges = true;
              }
            }
          });
          if (hasChanges) {
            dispatch(setQuestionDetails(newDetails));
          }
        }

        return res.data;
      })
      .catch(error => {
        dispatch(AxiosCallError(error));
      });
  };
};

export const updateMcqSeen = mcqId => {
  return (dispatch, getState) => {
    dispatch(AxiosCallRequest());
    const {
      invite: { assessment_id, test_id },
      auth: { user_id },
    } = getState();
    let url = `${ep}/api/assessments/${assessment_id}/update_mcq_status/`;

    let payload = {
      mcq_id: mcqId,
      user_id,
      test_id,
      is_seen: true,
    };

    return axios
      .post(url, payload)
      .then(res => {
        dispatch(AxiosCallSuccess());
      })
      .catch(error => {
        dispatch(AxiosCallError(error));
      });
  };
};

export const updateMcqMarkedForReview = (mcqId, markedForReview) => {
  return (dispatch, getState) => {
    const {
      invite: { assessment_id, test_id },
      auth: { user_id },
    } = getState();
    let url = `${ep}/api/assessments/${assessment_id}/update_mcq_status/`;

    let payload = {
      mcq_id: mcqId,
      user_id,
      test_id,
      marked_for_review: markedForReview,
    };

    return axios
      .post(url, payload)
      .then(res => {})
      .catch(error => {});
  };
};

export const createMeeting = assessment_id => {
  return async dispatch => {
    const url = `${ep}/api/assessments/${assessment_id}/meetings/`;
    try {
      const response = await axios.post(url);
      dispatch(createMeetingSuccess(response.data));
      return response.data;
    } catch (error) {
      console.error('Error creating meeting:', error);
      dispatch(AxiosCallError(error));
      throw error;
    }
  };
};

export const getMeeting = assessment_id => {
  return dispatch => {
    const url = `${ep}/api/assessments/${assessment_id}/meetings/`;
    return axios
      .get(url)
      .then(response => {
        dispatch(getMeetingSuccess(response.data));
        return response.data;
      })
      .catch(error => {
        if (error.response.status === 404) {
          return dispatch(createMeeting(assessment_id));
        } else {
          dispatch(AxiosCallError(error));
          throw error;
        }
      });
  };
};

export const fetchTestSettings = test_id => {
  return dispatch => {
    if (!test_id) {
      return;
    }
    dispatch(AxiosCallRequest());
    let ep1 = get_service_endpoint('copdg');
    let timestamp = new Date().getTime();
    let url = `${ep1}/api/tests/${test_id}/test_settings/`;
    axios
      .get(url)
      .then(response => {
        dispatch(getTestSettingsSuccess(response.data));
        dispatch(AxiosCallSuccess());
      })
      .catch(err => {
        dispatch(AxiosCallError(err));
      });
  };
};

export const fetchTestInfo = test_id => {
  return dispatch => {
    dispatch(AxiosCallRequest());
    let copdg = get_service_endpoint('copdg');
    let url = `${copdg}/api/test_info/${test_id}/`;
    axios
      .get(url)
      .then(response => {
        dispatch(getTestInfoSuccess(sectionInfoSerializer(response.data)));
        dispatch(AxiosCallSuccess());
      })
      .catch(err => {
        dispatch(getTestInfoSuccess(sectionInfoSerializer({})));
        dispatch(AxiosCallError(err));
      });
  };
};

export const getMeetingById = meeting_id => {
  return dispatch => {
    const url = `${ep}/api/meetings/${meeting_id}/`;
    axios
      .get(url)
      .then(response => {
        dispatch(getMeetingSuccess(response.data));
      })
      .catch(error => {
        dispatch(AxiosCallError(error));
      });
  };
};

export const getAttendee = (meeting_id, assessment_id) => {
  return dispatch => {
    const url = `${ep}/api/meetings/${meeting_id}/attendee/?assessment_id=${assessment_id}`;
    return axios
      .get(url)
      .then(response => {
        dispatch(getAttendeeSuccess(response.data));
        return response.data;
      })
      .catch(error => {
        dispatch(AxiosCallError(error));
        throw error;
      });
  };
};

export const startRecording = meeting_id => {
  return dispatch => {
    const url = `${ep}/api/meetings/${meeting_id}/recordings/`;
    axios
      .post(url)
      .then(response => {
        dispatch(startRecordingSuccess());
      })
      .catch(error => {
        dispatch(AxiosCallError(error));
      });
  };
};

export const stopRecording = meeting_id => {
  return (dispatch, getState) => {
    const url = `${ep}/api/meetings/${meeting_id}/`;
    axios
      .patch(url, { status: 'IN' })
      .then(response => {
        dispatch(stopRecordingSuccess());
      })
      .catch(error => {
        dispatch(AxiosCallError(error));
      });
  };
};

export const updateSectionStatus = (section_id, status) => {
  return (dispatch, getState) => {
    dispatch(AxiosCallRequest());
    const assessment_id = getState().assessment.id;
    const url = `${ep}/api/assessments/${assessment_id}/sections/${section_id}/`;
    const payload = { status };
    return axios
      .patch(url, payload)
      .then(response => {
        dispatch(AxiosCallSuccess());
        if (response.data.auto_start) {
          dispatch(setCurrentSectionId(response.data.auto_start.section_id));
        }
        return response;
      })
      .catch(error => {
        dispatch(AxiosCallError(error));
        return error;
      })
      .finally(() => {
        if (status === SECTION_STATUS_IN_PROGRESS) {
          dispatch(fetchSectionInfo(assessment_id));
          dispatch(fetchHeartbeat(assessment_id, HEARTBEAT_TYPE_SECTION));
        }
      });
  };
};

export const fetchSectionInfo = assessment_id => {
  return (dispatch, getState) => {
    axios
      .get(`${ep}/api/assessments/${assessment_id}/`)
      .then(response => {
        if (response.data.status !== 'PG') {
          dispatch(
            showErrorPage({
              errorType: 'Application Error',
              errorHeading: 'Assessment Complete',
              errorMessage: 'This assessment is complete and can no longer be viewed',
            }),
          );
          history.push('/error');
        } else {
          const { sections: serializedSections } = serializeSections(
            response.data.sections,
            window.location.pathname,
          );
          dispatch(
            updateSectionInfo({
              sections: serializedSections,
            }),
          );
        }
      })
      .catch(error => {
        console.log('error', error);
      });
  };
};

const calculateRemainingTime = (startTime, duration, currentServerTime) => {
  const elapsedSeconds = currentServerTime - startTime;
  const elapsedMinutes = elapsedSeconds / 60;
  const remainingMinutes = duration / 60 - elapsedMinutes;
  return Math.max(0, remainingMinutes * 60);
};

export const fetchHeartbeat = (
  assessment_id,
  type = HEARTBEAT_TYPE_OVERALL,
  currentSectionId = null,
) => {
  return (dispatch, getState) => {
    axios
      .get(`${ep}/api/heartbeat/${assessment_id}`)
      .then(response => {
        if (type === HEARTBEAT_TYPE_OVERALL) {
          const { startTime, currentServerTime, duration } = response.data;
          if (startTime && currentServerTime && duration) {
            const remainingTime = calculateRemainingTime(startTime, duration, currentServerTime);
            dispatch(updateOverallTimer(remainingTime));
          }
        } else if (type === HEARTBEAT_TYPE_SECTION && currentSectionId) {
          if (response.data.sections && Array.isArray(response.data.sections)) {
            response.data.sections.find(section => {
              if (
                section.id === currentSectionId &&
                section.startTime &&
                section.duration &&
                response.data.currentServerTime
              ) {
                const remainingTime = calculateRemainingTime(
                  section.startTime,
                  section.duration,
                  response.data.currentServerTime,
                );
                dispatch(updateSectionTimer({ sectionId: currentSectionId, remainingTime }));
                return true;
              }
              return false;
            });
          }
        }
      })
      .catch(error => {
        console.error(error);
        if (error.response && error.response.data.msg === ASSESSMENT_NOT_IN_PROGRESS) {
          const assessment = getState().assessment;
          if (
            type === HEARTBEAT_TYPE_OVERALL &&
            (assessment.remainingTime !== 0 || !isNaN(assessment.remainingTime))
          ) {
            dispatch(updateOverallTimer(0));
          } else if (type === HEARTBEAT_TYPE_SECTION && currentSectionId) {
            const section = assessment.sections.find(s => s.id === currentSectionId);
            if (section && (section.remaining_time !== 0 || !isNaN(section.remaining_time))) {
              dispatch(updateSectionTimer({ sectionId: currentSectionId, remainingTime: 0 }));
            }
          }
        }
      });
  };
};
